"use client";
import { Close } from "@/components/newIcons/Close";
import { Filter } from "@/components/newIcons/Filter";
import { Drawer } from "@/components/search/search/filters/Drawer";
import { useEffect, useState } from "react";
import { PrimaryButton, SecondaryButton } from "ui/components";
import type { SearchTags } from "../../_utils/SearchTagsSchema";
import type { PageTags } from "../../_utils/getPageTags";
import { Reset } from "./Reset";
import { Tags } from "./Tags";
import { useUpdateSearchParams } from "./useUpdateSearchParams";

type Props = {
  tags: PageTags;
  search: SearchTags;
  baseUrl: "/articles/conferencier/" | "/articles/actualite/";
};
export const Filters = ({ tags, search, baseUrl }: Props) => {
  const { updateSearchParams } = useUpdateSearchParams(baseUrl);
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [localTags, setLocalTags] = useState(search.tags);

  useEffect(() => {
    setLocalTags(search.tags);
  }, [search.tags]);

  const handleClose = () => {
    setIsFiltersOpen(false);
    updateSearchParams({
      tags: localTags,
      page: undefined,
    });
  };

  return (
    <>
      <div className="hidden md:flex justify-between items-start mt-2 mb-3">
        <div className="flex flex-wrap gap-2">
          <Tags
            allTags={tags.filter((t) => t.category === "Thème")}
            selectedTags={search.tags}
            localTags={localTags}
            setLocalTags={setLocalTags}
            isDesktop
            category="Thème"
            baseUrl={baseUrl}
          />
          <Tags
            allTags={tags.filter((t) => t.category === "Époque")}
            selectedTags={search.tags}
            localTags={localTags}
            setLocalTags={setLocalTags}
            isDesktop
            category="Époque"
            baseUrl={baseUrl}
          />
          <Tags
            allTags={tags.filter((t) => t.category === "Pays")}
            selectedTags={search.tags}
            localTags={localTags}
            setLocalTags={setLocalTags}
            isDesktop
            category="Pays"
            baseUrl={baseUrl}
          />
        </div>
      </div>
      <div className="flex px-3 justify-between sm:justify-evenly md:hidden">
        <SecondaryButton size="sm" onClick={() => setIsFiltersOpen(!isFiltersOpen)}>
          <Filter className="w-4 h-4 mr-[5px]" />
          FILTRER
        </SecondaryButton>
      </div>
      <Drawer open={isFiltersOpen} onClose={handleClose}>
        <div className="flex flex-col p-5">
          <div className="flex justify-between items-center pb-5 border-b border-[#E5E5E5]">
            <p className="text-xl font-bold">Filtrer</p>
            <PrimaryButton size="icon" onClick={handleClose}>
              <Close className="w-4 h-4" />
            </PrimaryButton>
          </div>
          <Tags
            allTags={tags.filter((t) => t.category === "Thème")}
            selectedTags={search.tags}
            localTags={localTags}
            setLocalTags={setLocalTags}
            category="Thème"
            baseUrl={baseUrl}
          />
          <Tags
            allTags={tags.filter((t) => t.category === "Époque")}
            selectedTags={search.tags}
            localTags={localTags}
            setLocalTags={setLocalTags}
            category="Époque"
            baseUrl={baseUrl}
          />
          <Tags
            allTags={tags.filter((t) => t.category === "Pays")}
            selectedTags={search.tags}
            localTags={localTags}
            setLocalTags={setLocalTags}
            category="Pays"
            baseUrl={baseUrl}
          />
          <div className="flex items-center justify-between py-5">
            <Reset localTags={localTags} onReset={() => setIsFiltersOpen(false)} baseUrl={baseUrl} />
            <div className="grow" />
            <PrimaryButton onClick={handleClose}>Afficher les voyages</PrimaryButton>
          </div>
        </div>
      </Drawer>
    </>
  );
};
